"use client";

import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import Image from "next/image";
import { useLocale } from "next-intl";
import { useGetFounder } from "@/app/hooks/main-hooks";

// const logos = [
//   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6BzngUhMT_0NKa911gBFsi-7MicgQFo-8rg&s",
//   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6BzngUhMT_0NKa911gBFsi-7MicgQFo-8rg&s",
//   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6BzngUhMT_0NKa911gBFsi-7MicgQFo-8rg&s",
//   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6BzngUhMT_0NKa911gBFsi-7MicgQFo-8rg&s",
//   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6BzngUhMT_0NKa911gBFsi-7MicgQFo-8rg&s",
//   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6BzngUhMT_0NKa911gBFsi-7MicgQFo-8rg&s",
// ];

export default function FounderProjects() {
  const locale = useLocale();

  const { data } = useGetFounder();

  const founders = data?.data || [];

  return (
    <section
      id="founder-led-projects"
      className="relative overflow-hidden bg-[#0a1b2e] py-28"
    >
      {/* Background Glow */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-1/3 top-0 h-96 w-96 -translate-y-1/2 rounded-full bg-[#c9a24d]/10 blur-[140px]" />
        <div className="absolute bottom-0 right-1/4 h-96 w-96 translate-y-1/2 rounded-full bg-white/5 blur-[140px]" />
      </div>

      <div className="mx-auto max-w-7xl px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mb-20 text-center"
        >
          <h2 className="text-4xl font-black text-white md:text-5xl">
            {locale === "en" ? "Founder-Led" : "بقيادة المؤسسين"}{" "}
            <span className="bg-linear-to-r from-[#c9a24d] to-[#e6c77a] bg-clip-text text-transparent">
              {locale === "en" ? "Implementations" : "التنفيذ"}
            </span>
          </h2>
          <p className="mt-6 text-lg text-[#e6c77a]/90">
            {locale === "en"
              ? "Projects personally led and delivered by our founders across multiple industries."
              : "مشاريع يقودها مؤسسونا ويتم تنفيذها عبر صناعات متعددة."}
          </p>
        </motion.div>

        {/* Swiper Logos */}
        <Swiper
          modules={[Autoplay]}
          loop
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          spaceBetween={24}
          slidesPerView={2}
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 5 },
          }}
        >
          {founders?.map((e: any) => (
            <SwiperSlide key={e?.id}>
              <motion.div
                initial={{ opacity: 0, scale: 0.85 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="border border-gray-200/20 rounded-2xl pb-5"
              >
                <div className="group flex h-40 items-center justify-center rounded-2xl border border-white/10 bg-white/5  backdrop-blur-sm transition-all relative hover:-translate-y-1 hover:border-[#c9a24d]/40 hover:bg-white/10 cursor-pointer">
                  <Image
                    src={e?.thumbnail}
                    alt={e?.name?.[locale]}
                    className="opacity-70 rounded-t-2xl w-full grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0"
                    fill
                    priority
                  />
                </div>
                <h3 className="mt-4 text-center text-white">
                  {e?.name?.[locale]}
                </h3>
              </motion.div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
